<template>
  <div class="home-wrap">
    <HomeHeader />
    <QuestionPopup />
    <CarouselList />
    <HomeInfo />
    <HomeNews />
    <VFooter />
  </div>
</template>

<script>
import HomeInfo from "./components/HomeInfo.vue";
import HomeNews from "./components/HomeNews.vue";
import VFooter from "@/components/footer/VFooter";
import HomeHeader from "./components/HomeHeader.vue";
import CarouselList from "./components/CarouselList.vue";
import QuestionPopup from "@/components/QuestionPopup/index.vue";

export default {
  components: {
    VFooter,
    HomeInfo,
    HomeNews,
    HomeHeader,
    CarouselList,
    QuestionPopup
  },
  name: "home",
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.home-wrap {
  position: relative;
  background: #f5f6f7;
}
</style>
